<template>
  <div id="opening">
    <div id="content">
      <Header
        :page="'opening'"
        :title_one="'opening'"
        :action_one="''"
      ></Header>
      <div class="description">
        <span
          v-html="$t('opening.description_' + user.event_name.toLowerCase())"
        ></span
        ><br /><br />
        <span
          v-html="
            $t('opening.description_response_' + user.event_name.toLowerCase())
          "
        ></span>
      </div>
      <br />
    </div>

    <v-select
      v-if="opening != ''"
      :items="openingOptions"
      v-model="opening"
      item-text="name"
      item-value="value"
      :class="{ answered: answered }"
      :disabled="!event.transfers"
      :item-disabled="(item) => item.value == '0'"
      @change="changeOpening()"
      style="width: 400px"
    ></v-select>

    <div id="content">
      <div class="description">
        <span v-html="$t('opening.condition_1')"></span>
        <br /><br />
        <span v-html="$t('opening.condition_2')"></span>
      </div>
      <br />
    </div>

    <SuccessPopup
      @close="closePopup()"
      @input="closePopup()"
      :dialog="success"
    ></SuccessPopup>
  </div>
</template>
<script>
import i18n from '@/i18n'
import Header from '@/components/layout/Header'
import Equipment from '@/components/ui/Equipment.vue'
import SuccessPopup from '@/components/ui/SuccessPopup.vue'

export default {
  name: 'opening',
  components: {
    Header,
    Equipment,
    SuccessPopup
  },
  data () {
    return {
      openingOptions: [
        { value: '0', name: i18n.t('nsnc') },
        { value: '2', name: i18n.t('no') },
        { value: '1', name: i18n.t('si') }
      ],
      opening: '',
      success: false,
      answered: false
    }
  },
  computed: {
    user () {
      return this.$store.getters['user/getUser']
    },

    event () {
      return this.$store.getters['getCurrentEvent']()
    }
  },
  created () {
    this.load()
  },
  methods: {
    load () {
      this.$overlay.show()
      var self = this
      // scroll to top
      window.scroll(0, 0)

      if (this.user.admin) {
        this.$store
          .dispatch('club/loadClubEvent', {
            club_id: this.user.club_id,
            event_id: this.user.event_id
          })
          .then(function () {
            var data = self.$store.getters['club/getClub']
            self.opening = data.teams[self.$route.params.team_id].opening
            if (self.opening != '0') {
              self.answered = true
              self.openingOptions.shift()
            }
            self.$overlay.hide()
          })
      } else {
        this.$store
          .dispatch('team/loadTeam', { team_id: this.user.team_id })
          .then(function () {
            var data = self.$store.getters['team/getTeam']
            console.log(data)
            self.opening = data.team.opening
            if (self.opening != '0') {
              self.answered = true
              self.openingOptions.shift()
            }
            self.$overlay.hide()
          })
      }
    },

    changeOpening () {
      var self = this

      if (this.user.admin) {
        this.success = false
        this.$store
          .dispatch('team/updateOpening', {
            team_id: this.$route.params.team_id,
            value: this.opening
          })
          .then(function () {
            self.success = true
          })
      } else {
        this.success = false
        this.$store
          .dispatch('team/updateOpening', {
            team_id: this.user.team_id,
            value: this.opening
          })
          .then(function () {
            self.success = true
          })
      }
    }
  },
  watch: {
    $route: 'load'
  }
}
</script>
<style lang="scss" scoped>
.mobile {
  display: none;
}

#content {
  padding: 0 12px !important;
  padding-bottom: 50px !important;

  .download {
    width: fit-content;
    cursor: pointer;
  }

  .row {
    background-color: #f5f5f5;
    border-radius: 3px;
    text-align: center;
    overflow: hidden;
    margin-bottom: 24px;
    padding: 6px 12px;
    height: auto;
    // min-height: 100px;

    &.nobackground {
      background-color: unset;
    }

    .item {
      display: inline-block;
      margin-bottom: 6px;
      width: 100%;

      &.mid {
        width: 50%;
      }

      .alergy {
        color: inherit;
        font-size: inherit;
        font-weight: inherit;

        &:after {
          content: ", ";
        }
        &:last-of-type:after {
          content: "";
        }
      }
    }

    .label,
    .value {
      display: inline-block;
      font-size: 15px;
    }
    .label {
      width: 100px;
      text-align: right;
      margin-right: 12px;
      text-transform: uppercase;
      font-size: 12px;

      &:after {
        content: ":";
      }
    }
    .value {
      font-weight: bold;
    }
  }

  .title {
    font-size: 16px !important;
    font-weight: bold;
    color: #191919;
    display: block;
    width: 100%;
    margin: 6px;
    font-family: AvantGarde-Bold !important;
    text-transform: uppercase;
    padding: 2px 0;

    &.sub {
      margin-left: 12px;
    }
  }

  .opening {
    background: none;
    width: 100%;
    overflow: hidden;
    text-align: left;

    .opening-role,
    .opening-name {
      @include text-ellipsis();
      display: block;
      font-size: 24px;
      color: $main-color;
      width: 100%;
      padding: 2px;
    }

    .opening-role {
      margin-right: 6px;
      text-transform: uppercase;
      font-weight: bold;
      font-size: 16px;
      line-height: 16px;
    }
  }

  .left,
  .right {
    width: 50%;
    display: inline-block;
    padding: 12px;
  }
  .left {
  }
  .right {
  }
}

@include media("<=desktop") {
  #content {
    padding: 12px !important;

    .left,
    .right {
      width: 100%;
      display: block;
      padding: 0;
    }
  }
}

@include media(">phone", "<tablet") {
  #content {
    .row {
      .item {
        &.mid {
          width: 100%;
        }
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.mainButton {
  width: 150px !important;
  padding: 0;
  margin: 0;
  height: 100%;
  min-width: 40px;
  outline: none;
  cursor: pointer;
  font-size: 8pt;
  font-family: Speedee-Bold;
  border-radius: 3px;
  border: 1px solid #fc8926;
  text-transform: uppercase;
  background-color: transparent;
  color: #c55c00;
  height: 40px;
  padding: 0;
  font-family: Roboto-Bold;
  font-size: 14px;
  line-height: 14px;
  transition: background-color 0.5s ease;
  float: left;

  &:hover {
    background-color: #fc8a2623 !important;
  }
}

.section {
  float: left;
  display: block;
  width: 100%;
}

.search {
  float: right;
}

.dataTable {
  > div {
    table {
      text-align: center;
      width: 100%;
      margin: 20px auto 0;
      border-radius: 5px;

      overflow: visible;
      min-width: 600px;

      th {
        background-color: $secondary-color;
        background-color: #ddd;
      }
      td,
      th {
        border: 1px solid $secondary-color;
        padding: 12px !important;
        text-align: left;
        border-left: 0;
        border-right: 0;
        min-width: 60px;
      }

      tr:nth-child(even) {
        background-color: #f7f7f7;
      }

      th {
        font-weight: normal;
        border: 0 solid $secondary-color;
        color: $main-color;
        color: #333;
        padding: 20px;
        text-transform: uppercase;
      }
      th.column[role="columnheader"] {
        padding: 20px 12px 12px 12px !important;
      }

      th:nth-child(1) {
        width: 20%;
      }

      th:nth-child(2) {
        width: 20%;
      }

      th:nth-child(3) {
        width: 20%;
      }

      th:nth-child(4) {
        width: 20%;
      }

      th:nth-child(5) {
        width: 10%;
      }

      th:nth-child(6) {
        width: 10%;
      }

      tr:last-child {
        // border-bottom: 4px solid $main-color;
      }
    }
  }
}
</style>

<style lang="scss">
.answered {
  .v-input__control {
    .v-input__slot {
      .v-select__slot {
        background-color: #eee;
      }
    }
  }
}
</style>
